import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Invoice,
  InvoiceResponse,
  InvoicesByPhoneResponse,
} from '@core/interfaces/invoice.interface';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InvoicesService {
  public urlBackEnd: string = environment.base_url;

  constructor(private http: HttpClient) {}

  getInvoicesByPhone(phone: string): Observable<InvoicesByPhoneResponse> {
    return this.http
      .get<InvoicesByPhoneResponse>(`${this.urlBackEnd}/invoices/${phone}`)
      .pipe(catchError(this.handleError));
  }

  getInvoiceByCode(
    phone: string,
    invoiceCode: string,
  ): Observable<InvoiceResponse> {
    return this.http
      .get<InvoiceResponse>(
        `${this.urlBackEnd}/invoices/${phone}/${invoiceCode}`,
      )
      .pipe(catchError(this.handleError));
  }

  createInvoice(
    phone: string,
    data: Partial<Invoice>,
  ): Observable<InvoiceResponse> {
    return this.http
      .post<InvoiceResponse>(`${this.urlBackEnd}/invoices/${phone}`, data)
      .pipe(catchError(this.handleError));
  }

  updateInvoice(
    phone: string,
    invoiceCode: string,
    data: Partial<Invoice>,
  ): Observable<InvoiceResponse> {
    return this.http
      .put<InvoiceResponse>(
        `${this.urlBackEnd}/invoices/${phone}/${invoiceCode}`,
        data,
      )
      .pipe(catchError(this.handleError));
  }

  deleteInvoice(phone: string, invoiceCode: string): Observable<any> {
    return this.http
      .delete(`${this.urlBackEnd}/invoices/${phone}/${invoiceCode}`)
      .pipe(catchError(this.handleError));
  }

  getInvoicePdfUrl(phone: string, invoiceCode: string): string {
    return `${this.urlBackEnd}/invoices/${phone}/${invoiceCode}/pdf`;
  }

  private handleError(error: HttpErrorResponse) {
    console.error('HTTP Error:', error.status, error.error?.msg);
    return throwError(() => error);
  }
}
